<template>
<div class="chapter">
<div class="inner_page">
<h1 id="sigil_toc_id_4" title="Dedication"></h1>
<p class="firstcenter"><span class="b-i">In honor of Richard L. Twiss</span></p>
<p class="center"><em class="i">June 11, 1954–February 9, 2013</em></p>
<p class="firstcenter"></p>
<p class="ifirstcenter">A follower of the Jesus Way<br/>
  and a real human being</p>
<div class="picture"><img alt="" class="shrule" src="Images/ded.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?57c24b94